var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgThumbsUpDark = function SvgThumbsUpDark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "thumbs-up-dark-path-1",
    d: "M0 0h64v64H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "thumbs-up-dark-(DEV)-Assets",
    fill: "none",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("g", {
    id: "thumbs-up-dark-icon-dark-thumbs-up"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "thumbs-up-dark-mask-2",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#thumbs-up-dark-path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "thumbs-up-dark-icon-thumbs-up",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#thumbs-up-dark-mask-2)"
  }, /*#__PURE__*/React.createElement("g", {
    strokeWidth: 2,
    transform: "translate(10 5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "thumbs-up-dark-Group-16",
    stroke: "#30B7FD",
    transform: "rotate(-90 12 -4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "thumbs-up-dark-Path",
    d: "m0 15.05 5.64 2.05M5.64 0 0 2.05M7.15 8.55h-6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "thumbs-up-dark-Group-5",
    stroke: "#00293C",
    transform: "translate(0 11)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "thumbs-up-dark-Stroke-1",
    d: "M9 33.826C9 39.446 13.555 44 19.174 44h18.23a3.57 3.57 0 0 0 3.56-3.56 3.57 3.57 0 0 0-3.56-3.562H34.28h4.14a3.57 3.57 0 0 0 3.56-3.56 3.57 3.57 0 0 0-3.56-3.56h-3.14 4.158a3.57 3.57 0 0 0 3.56-3.562 3.57 3.57 0 0 0-3.56-3.56c.149 0-3.301.017-3.158 0h3.159c.222-.005.7-.07.715-.074A3.575 3.575 0 0 0 43 19.074a3.57 3.57 0 0 0-3.561-3.56H26.295S30.704 10.3 27.53 3.365C26.186.43 24.424 0 23.06 0 21.026 0 21 4.071 20.23 6.477 17.585 14.737 11.779 20.6 9 20.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "thumbs-up-dark-Stroke-3",
    d: "M6 17.5H3c-1.65 0-3 1.35-3 3V41c0 1.65 1.35 3 3 3h3c1.65 0 3-1.35 3-3V20.5c0-1.65-1.35-3-3-3"
  }))))))));
};
export default SvgThumbsUpDark;